export default __webpack_public_path__ + "static/media/proSapient_logo.8e75ac96.png";